import gql from 'graphql-tag';

export default gql`
  query itemHistoryContent($moduleName: String, $selectedRow: AccountRowInput) {
    itemHistoryContent(moduleName: $moduleName, selectedRow: $selectedRow) {
      AcctNo
      AcctName
      Code
      Description
      Country
      Date
      Qty
      Price
      CurrentPricing
      Availability
      Uom
    }
  }
`;
